(() => {
  angular
    .module('gm.common.filters')
    .filter('gmyCapitalize', gmyCapitalize);

  function gmyCapitalize() {
    'ngInject';

    return input => ((input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '');
  }
})();
